var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{style:({width: '1200px', height: '250px'}),attrs:{"id":"huodexindai3"}}),_c('div',{style:({width: '1200px', height: '250px'}),attrs:{"id":"huodexindai2"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }